export default __webpack_public_path__ + "static/media/pic02.e2a6f881.jpg";